///<reference path="../../definitions/weather.d.ts"/>
///<reference path="../util/SDTDate.ts"/>
///<reference path="../Const.ts"/>

namespace app.model{
	import SDTDate = app.util.SDTDate;
	export class Pinpoint{
		data:PinpointData;

		public parseData(json:any, location:string){
			let baseDate = new SDTDate(json["announced_date"], Const.DATE_PINPOINT_BASE),
				createDate = new SDTDate(json["create_date_str"], Const.DATE_PINPOINT_CREATION);


			let data:PinpointJSON = json[location],
				items:PinpointDateItem[] = [],
				item:PinpointDateItem;

			data.prec_date.forEach((elm, i) => {
				if(items.length < 8){
					let date = new SDTDate(elm, Const.DATE_PINPOINT_ITEM);
					if(
						items[0] &&
						items[0].date.getMonth() == 11 &&
						date.getMonth() == 0
					){
						date.addYear(1);
					}

					item = {
						date:date,
						weather:this.getDataFromTable(date, data.wx, baseDate),
						prec:data.prec[i],
						pop:this.getPop(date, data, createDate),
						temp:this.getDataFromTable(date, data.temp, baseDate)
					};
					items.push(item);
				}
			});

			this.data = {
				createDate:createDate,
				name:data.name,
				items:items
			};
		}

		private getDataFromTable(target:SDTDate, table:number[], base:SDTDate):number{
			let result:number,
				current;

			for(let i:number = 0; i < table.length; i++){
				current = base.copy();
				current.addHour(i);
				if(current.toString() == target.toString()){
					result = table[i];;
					break;
				}
			}

			return result
		}

		private getPop(target:SDTDate, data:PinpointJSON, base:SDTDate){
			let result:number;
			switch(true){
				case target.getIsToday(base) && target.timeSpan == 0:
					result = data.pop.today_pop0006;
					break;
				case target.getIsToday(base) && target.timeSpan == 1:
					result = data.pop.today_pop0612;
					break;
				case target.getIsToday(base) && target.timeSpan == 2:
					result = data.pop.today_pop1218;
					break;
				case target.getIsToday(base) && target.timeSpan == 3:
					result = data.pop.today_pop1824;
					break;
				case target.getIsTomorrow(base) && target.timeSpan == 0:
					result = data.pop.tomorrow_pop0006;
					break;
				case target.getIsTomorrow(base) && target.timeSpan == 1:
					result = data.pop.tomorrow_pop0612;
					break;
				case target.getIsTomorrow(base) && target.timeSpan == 2:
					result = data.pop.tomorrow_pop1218;
					break;
				case target.getIsTomorrow(base) && target.timeSpan == 3:
					result = data.pop.tomorrow_pop1824;
					break;
			}

			return result;

		}

	}
}